import React, { useEffect, useState } from 'react'
import Header from '../master/SideBar'
import Nav from '../master/NavBar'
import { getSessions } from '../../api/SessionsService';
import { StaffList } from '../../api/Staff';
import { ToastMain ,SweetAlertShow} from '../master/Master';
import { getstaffwithid } from '../../api/FacultyService';
import { imgBaseUrl } from '../../api/api';
import StaffHeader from './StaffHeader';

const ExperienceCertificate = () => {
    const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('');
    const [session, setSession] = useState('');
    const [selectedSession, setSelectedSession] = useState('');
    const [staff, setStaff] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState('');
    const [experience, setExperience] = useState();
    const [classLevel, setClassLevel] = useState('');
    const [singleStaff, setSingleStaff] = useState('');


    const getSession = async () => {
        setLoading(true);
        try {
            const response = await getSessions();
            if (response?.data?.status) {
                const ActiveSession = response?.data?.data?.find((s) => s?.status == '1')
                setSession(response?.data);
                setSelectedSession(ActiveSession?.id)
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.messsage || 'something went wrong'
                // })
                SweetAlertShow('info','Warning',response?.data?.messsage)
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.messsage || 'something went wrong'
            // })

            SweetAlertShow('error','Error',error?.response?.data?.messsage ?? error?.messsage)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getSession();

    }, [])

    const getStaff = async () => {
        setLoading(true)
        const addUrl = `&session_id=${selectedSession}`
        try {
            const response = await StaffList(addUrl);
            if (response?.data?.status) {
                setStaff(response?.data?.data || [])
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.messsage || 'something went wrong'
                // })
                SweetAlertShow('info','Warning',response?.data?.messsage)
            }
        } catch (error) {
            SweetAlertShow('error','Error',error?.response?.data?.messsage  ?? error?.messsage)
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.messsage || 'something went wrong'
            // })

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (selectedSession) {
            getStaff();
        }
    }, [selectedSession]);

    const StaffById = async (selectedStaff) => {
        setLoading(true);
        // const addUrl = `id=${selectedStaff}`
        try {
            const response = await getstaffwithid(selectedStaff);
            if (response?.data?.status) {
                setSingleStaff(response?.data?.data || []);
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.messsage || 'something went wrong'
                // })

                SweetAlertShow('info','Warning',response?.data?.messsage)
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.messsage || 'something went wrong'
            // })
            SweetAlertShow('error','Error',error?.response?.data?.messsage ?? error?.messsage)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (selectedStaff) {
            StaffById(selectedStaff)
        }
    }, [selectedStaff]);

    const handlePrintCertificate = (staff, instituteData, type, experience, classLevel, imgBaseUrl) => {
        const printWindow = window.open("", "_blank");

        // ✅ Normalize staff type for flexible usage
        const staffType = (type || staff?.type_id || "Staff").toLowerCase();

        // ✅ Decide title and text dynamically
        let roleTitle = "Experience Certificate";
        let designationText = "as a dedicated member of our institution";

        if (staffType.includes("teacher")) {
            roleTitle = "Teacher Experience Certificate";
            designationText = `as a <b>Teacher</b>${classLevel ? `, teaching classes ${classLevel}` : ""}`;
        } else if (staffType.includes("driver")) {
            roleTitle = "Driver Experience Certificate";
            designationText = "as a <b>Driver</b>";
        } else if (staffType.includes("accountant")) {
            roleTitle = "Accountant Experience Certificate";
            designationText = "as an <b>Accountant</b>";
        } else if (staffType.includes("computer")) {
            roleTitle = "Computer Operator Experience Certificate";
            designationText = "as a <b>Computer Operator</b>";
        } else if (staffType.includes("administrative")) {
            roleTitle = "Administrative Staff Experience Certificate";
            designationText = "as an <b>Administrative Staff Member</b>";
        }

        // ✅ Format joining date & issue date
        const joiningDate = staff?.join_date
            ? new Date(staff.join_date).toLocaleDateString("en-IN", {
                year: "numeric",
                month: "long",
                day: "numeric",
            })
            : "________";

        const issueDate = new Date().toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

        // ✅ HTML for print
        printWindow.document.write(`
  <html>
    <head>
      <title>${roleTitle}</title>
      <style>
        body {
          font-family: 'Arial', sans-serif;
          margin: 50px;
          line-height: 1.8;
          color: #000;
          background: #fff;
          position: relative;
        }
        .certificate {
          border: 2px solid #000;
        //   border: 2px solid #009688;
          padding: 40px;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
          position: relative;
          overflow: hidden;
        }

        /* ===== WATERMARK ===== */
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-25deg);
          font-size: 40px;
          color: rgba(0, 0, 0, 0.05);
          white-space: nowrap;
          pointer-events: none;
          z-index: 0;
          font-weight: 700;
          text-transform: uppercase;
        }

        /* ===== HEADER ===== */
        .header {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
          margin-bottom: 25px;
          position: relative;
          z-index: 2;
        }
        .logo {
          flex: 0 0 100px;
          text-align: center;
        }
        .logo img {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }
        .school-info {
          flex: 1;
          text-align: center;
          line-height: 1.5;
        }
        .school-info h2 {
          margin: 0;
          color: #000;
          font-size: 22px;
          font-weight: bold;
        }
        .school-info p {
          margin: 3px 0;
          font-size: 14px;
          color: #333;
        }

        /* ===== CONTENT ===== */
        .content {
          margin-top: 20px;
          font-size: 16px;
          text-align: justify;
          position: relative;
          z-index: 2;
        }
        .content h3 {
          text-align: center;
          text-decoration: underline;
          color: #000;
        }

        /* ===== FOOTER ===== */
        .footer {
          margin-top: 60px;
          display: flex;
          justify-content: space-between;
          position: relative;
          z-index: 2;
        }
        .sign {
          text-align: center;
          width: 40%;
          border-top: 1px solid #000;
          padding-top: 8px;
          font-size: 14px;
          font-weight: bold;
        }

        /* ===== DATE SECTION ===== */
        .dates {
          margin-top: 30px;
          text-align: right;
          font-size: 14px;
          color: #333;
          position: relative;
          z-index: 2;
        }

        @media print {
          body {
            margin: 20px;
          }
          .watermark {
            color: rgba(0, 0, 0, 0.08);
          }
        }
      </style>
    </head>
    <body>
      <div className="certificate">
        <!-- Watermark -->
        <div className="watermark">${(instituteData?.name || "SCHOOL ERP SOFTWARE").toUpperCase()}</div>

        <div className="header">
          <div className="logo">
            <img src="${instituteData?.logo_img
                ? `${imgBaseUrl}${instituteData.logo_img}`
                : "/files/logo.png"
            }" alt="School Logo" />
          </div>
          <div className="school-info">
            <h2>${instituteData?.name || "SCHOOL ERP SOFTWARE"}</h2>
            <p>${instituteData?.address ||
            `${instituteData?.village || ""}, ${instituteData?.district || ""
            } (${instituteData?.state || ""})`
            }</p>
            <p>Contact: ${instituteData?.phone || instituteData?.mobile || ""} | Email: ${instituteData?.email || ""
            }</p>
          </div>
        </div>

        <div className="content">
          <h3>${roleTitle}</h3>
          <p>
            This is to certify that <b>${staff?.gender === "Female" ? "Ms." : "Mr."} ${staff?.name || "________"
            }</b> has worked ${designationText} 
            at <b>${instituteData?.name || "the institution"}</b>.
          </p>
          <p>
            He/She joined on <b>${joiningDate}</b> and served the institution for a period of <b>${experience || "___"
            }</b> years.
          </p>
          <p>
            During this period, ${staff?.name?.split(" ")[0] || "He/She"} has demonstrated excellent 
            performance, sincerity, and dedication towards duties assigned.
          </p>
          <p>
            We wish ${staff?.name?.split(" ")[0] || "the staff"} success in all future endeavors.
          </p>

          <div className="dates">
            <p><b>Issue Date:</b> ${issueDate}</p>
          </div>
        </div>

        <div className="footer">
          <div className="sign">Authorized Signatory</div>
          <div className="sign">${instituteData?.name || ""}</div>
        </div>
      </div>

      <script>
        window.print();
        window.onafterprint = function() { window.close(); }
      </script>
    </body>
  </html>
  `);

        printWindow.document.close();
    };






    return (
        <>
            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        
                            <div className="container-fluid mt-2">
                                <div className="row">
                                <div className="d-flex gap-2">
                               <div className="col-md-3">
                                 <StaffHeader data={'Staff Portal'}/>
                               </div>

                               <div className="col-md-9">
                                 <div className="card">
                                    <div className="card-body">
                                        <h3>Experience Certificated</h3>
                                        <div className="row">
                                            {/* {JSON.stringify(staff)} */}
                                            <div className="col-md-3">
                                                <div className="form-floating form-floating-outline">
                                                    <select className='form-select' name="staff_id" id="staff" value={selectedStaff} onChange={(e) => {
                                                        setSelectedStaff(e.target.value)
                                                    }}>
                                                        <option>
                                                            Select Staff
                                                        </option>
                                                        {staff?.map((item, index) => (
                                                            <option key={item?.id} value={item?.id}>
                                                                {item?.name} : ({item?.staff_type})
                                                            </option>
                                                        ))}
                                                        <label htmlFor="staff">Select Staff</label>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-floating form-floating-outline">
                                                    <select className='form-select' name="type" id="type" value={type} onChange={(e) => setType(e.target.value)}>
                                                        <option>Select Type</option>
                                                        <option value={'driver'}>Driver</option>
                                                        <option value={'teacher'}>Teaching</option>
                                                        <option value={'computer'}>Computer</option>
                                                        <option value={'accountant'}>Accountant</option>
                                                        <option value="administrative">Administrative Staff</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {type == 'teacher' && (
                                                <>
                                                    <div className="col-md-3">
                                                        <div className="form-floating form-floating-outline">
                                                            <input className='form-control' type="text" name='' placeholder='Class' id='class' onChange={(e) => setClassLevel(e.target.value)} />
                                                            <label htmlFor="class">Class</label>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            <div className="col-md-3">
                                                <div className="form-floating form-floating-outline">
                                                    <input className='form-control' name='experience' type="text" placeholder='Experience in year' id='year' onChange={(e) => setExperience(e.target.value)} />
                                                    <label htmlFor="year">Experience</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mt-3">
                                    <div className="card-body">
                                        <div className="col-md-6 mx-auto">
                                            {singleStaff && singleStaff?.name && (
                                                <div
                                                    className="certificate-preview shadow p-4 rounded position-relative"
                                                    style={{
                                                        lineHeight: 1.8,
                                                        backgroundColor: "#fff",
                                                        border: "2px solid #009688",
                                                        fontFamily: "Arial, sans-serif",
                                                        color: "#000",
                                                    }}
                                                >
                                                    {/* Header */}
                                                    <div className="border-bottom pb-2 mb-3 text-center">
                                                        <div className="d-flex align-items-center justify-content-center mb-2">
                                                            <img
                                                                src={
                                                                    instituteData?.logo_img
                                                                        ? `${imgBaseUrl}${instituteData.logo_img}`
                                                                        : "/files/logo.png"
                                                                }
                                                                alt="School Logo"
                                                                style={{
                                                                    width: "70px",
                                                                    height: "70px",
                                                                    objectFit: "contain",
                                                                    marginRight: "15px",
                                                                }}
                                                            />
                                                            <div>
                                                                <h5 className="mb-0" style={{ color: "#009688", fontWeight: "bold" }}>
                                                                    {instituteData?.name || "SCHOOL ERP SOFTWARE"}
                                                                </h5>
                                                                <p className="mb-0" style={{ fontSize: "13px" }}>
                                                                    {instituteData?.address ||
                                                                        `${instituteData?.village || ""}, ${instituteData?.district || ""
                                                                        } (${instituteData?.state || ""})`}
                                                                </p>
                                                                <p className="mb-0" style={{ fontSize: "13px" }}>
                                                                    Contact: {instituteData?.phone || instituteData?.mobile || "N/A"} |{" "}
                                                                    {instituteData?.email || ""}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Title */}
                                                    <h4
                                                        className="text-center mb-3"
                                                        style={{
                                                            fontWeight: "bold",
                                                            textDecoration: "underline",
                                                            color: "#000",
                                                        }}
                                                    >
                                                        {type === "driver"
                                                            ? "Driver Experience Certificate"
                                                            : type === "computer"
                                                                ? "Computer Operator Experience Certificate"
                                                                : type === "accountant"
                                                                    ? "Accountant Experience Certificate"
                                                                    : type === "teacher"
                                                                        ? "Teacher Experience Certificate"
                                                                        : "Experience Certificate"}
                                                    </h4>

                                                    {/* Content */}
                                                    <div className="text-justify px-3">
                                                        <p>
                                                            This is to certify that{" "}
                                                            <b>
                                                                {singleStaff?.gender === "Female" ? "Ms." : "Mr."} {singleStaff?.name}
                                                            </b>{" "}
                                                            has worked as a{" "}
                                                            <b>
                                                                {type === "driver"
                                                                    ? "Driver"
                                                                    : type === "computer"
                                                                        ? "Computer Operator"
                                                                        : type === "accountant"
                                                                            ? "Accountant"
                                                                            : type === "teacher"
                                                                                ? "Teacher"
                                                                                : "Staff Member"}
                                                            </b>{" "}
                                                            at <b>{instituteData?.name || "Our Institution"}</b>
                                                            {type == "teacher" && classLevel ? `, teaching classes ${classLevel},` : ""} for a
                                                            period of <b>{experience || "___"}</b> years.
                                                        </p>

                                                        {singleStaff?.join_date && (
                                                            <p>
                                                                He/She joined the institution on{" "}
                                                                <b>
                                                                    {new Date(singleStaff.join_date).toLocaleDateString("en-IN", {
                                                                        day: "2-digit",
                                                                        month: "long",
                                                                        year: "numeric",
                                                                    })}
                                                                </b>
                                                                .
                                                            </p>
                                                        )}

                                                        <p>
                                                            During this period, {singleStaff?.name?.split(" ")[0]} has shown excellent conduct,
                                                            punctuality, and dedication to duty.
                                                        </p>

                                                        <p>
                                                            We wish {singleStaff?.name?.split(" ")[0]} all the best in future endeavors.
                                                        </p>

                                                        {/* Issue Date */}
                                                        <p className="text-end mt-4" style={{ fontSize: "14px" }}>
                                                            <b>Issue Date:</b>{" "}
                                                            {new Date().toLocaleDateString("en-IN", {
                                                                day: "2-digit",
                                                                month: "long",
                                                                year: "numeric",
                                                            })}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between mt-5 px-4">
                                                        <div
                                                            style={{
                                                                width: "40%",
                                                                borderTop: "1px solid #000",
                                                                textAlign: "center",
                                                                paddingTop: "6px",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            Authorized Signatory
                                                        </div>
                                                        <div
                                                            style={{
                                                                width: "40%",
                                                                borderTop: "1px solid #000",
                                                                textAlign: "center",
                                                                paddingTop: "6px",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            {instituteData?.name || ""}
                                                        </div>
                                                    </div>

                                                    {/* Print Button */}
                                                    <div className="text-center mt-4">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() =>
                                                                handlePrintCertificate(
                                                                    singleStaff,
                                                                    instituteData,
                                                                    type,
                                                                    experience,
                                                                    classLevel,
                                                                    imgBaseUrl
                                                                )
                                                            }
                                                        >
                                                            <i className="fa fa-print me-2"></i> Print Certificate
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                               </div>
                                </div>

                                </div>

                            </div>
                       
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExperienceCertificate
